import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrustPaymentCardPage } from './trustpayment-card.page';

const routes: Routes = [
  {
    path: '',
    component: TrustPaymentCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrustPaymentCardPageRoutingModule {}
